import React from "react";

const STATUS_MAP = {
  bozza:     { label: "Bozza",     cls: "bg-gray-100 text-gray-800 border-gray-300" },
  inviato:   { label: "Inviato",   cls: "bg-blue-100 text-blue-800 border-blue-300" },
  accettato: { label: "Accettato", cls: "bg-amber-100 text-amber-800 border-amber-300" },
  firmato:   { label: "Firmato",   cls: "bg-green-100 text-green-800 border-green-300" },
  rifiutato: { label: "Rifiutato", cls: "bg-red-100 text-red-800 border-red-300" },
};

export default function StatusBadge({ stato }) {
  const s = STATUS_MAP[stato] || STATUS_MAP.bozza;
  return (
    <span
      data-testid={`status-badge-${stato}`}
      className={`inline-flex items-center gap-1 px-2.5 py-1 text-[10px] uppercase tracking-[0.15em] font-bold border rounded-sm ${s.cls}`}
    >
      {s.label}
    </span>
  );
}
